import { Reducer } from "react";
import { AnyAction } from "redux";
import {
    FETCH_USER_DATA,
    LOGIN_FAIL,
    LOGIN_SUCCESS,
    LOGOUT,
    REFRESH_TOKEN,
    UPDATE_EMAIL_OPTED,
} from "../actions/auth/types";
import { AuthState } from "./state";
import { fetchUserData } from "../actions/auth";

const user = JSON.parse(localStorage.getItem("user") as any);
// const user = TokenService.decodeJWT();
const isUserData = !!user;
if (!user) {
    // get user by token in local storage & set to user state
    (async () => {
        await fetchUserData();
    })();
}

const initialState: AuthState = {
    isLoggedIn: isUserData,
    user: null,
    userRole: "",
};

const authReducer: Reducer<AuthState, AnyAction> = (state = initialState, action: AnyAction) => {
    const { type, payload } = action;
    switch (type) {
        case LOGIN_SUCCESS:
            return {
                isLoggedIn: true,
                user: payload.user,
                userRole: payload.userRole,
            };
        case LOGIN_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        case LOGOUT:
            return {
                isLoggedIn: false,
                user: null,
                userRole: "",
            };
        case REFRESH_TOKEN:
            return {
                ...state,
                user: { ...state.user, accessToken: payload },
            };
        case UPDATE_EMAIL_OPTED:
            return {
                ...state,
                user: { ...state.user, emailOpted: payload },
            };
        case FETCH_USER_DATA:
            return {
                ...state,
                user: { ...state.user, ...payload },
            };
        default:
            return state;
    }
};

export default authReducer;
